<quill-editor #editor [modules]="quillModules" placeholder="" [(ngModel)]="content"
    oncontextmenu="return false;" (onContentChanged)="contentChange($event)"></quill-editor>